import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { Sparkles, ArrowUpRight } from "lucide-react";

/**
 * Compact AI-usage strip rendered at the top of Forge.
 * Reads /api/forge/usage — non-blocking; hides on error.
 */
export default function ForgeUsage() {
  const [u, setU] = useState(null);
  useEffect(() => {
    api.get("/forge/usage").then(r => setU(r.data)).catch(() => setU(null));
  }, []);
  if (!u) return null;

  const used = u.daily_calls || 0;
  const cap = u.limits?.daily_calls || 0;
  const pct = cap > 0 ? Math.min(100, Math.round((used / cap) * 100)) : 0;
  const isLow = u.remaining_today <= Math.max(5, cap * 0.1);

  return (
    <div className="mx-4 sm:mx-6 lg:mx-10 mt-4" data-testid="forge-usage-strip">
      <div className="surface px-4 py-3 flex items-center gap-4 flex-wrap">
        <div className="inline-flex items-center gap-2 shrink-0">
          <div className="h-7 w-7 rounded-lg bg-ai-soft text-ai grid place-items-center"><Sparkles className="h-3.5 w-3.5" /></div>
          <div className="leading-tight">
            <p className="text-[10px] uppercase tracking-wider text-meta font-bold">AI usage today</p>
            <p className="text-sm font-bold text-ink">
              {used.toLocaleString()} <span className="text-meta font-normal">/ {cap.toLocaleString()} calls</span>
            </p>
          </div>
        </div>
        <div className="flex-1 min-w-[140px]">
          <div className="h-1.5 rounded-full bg-zinc-100 overflow-hidden">
            <div className={`h-full ${isLow ? "bg-warning" : "ashra-gradient-bg"}`} style={{ width: `${pct}%` }} />
          </div>
        </div>
        <div className="text-right shrink-0">
          <p className="text-[10px] uppercase tracking-wider text-meta font-bold">This month</p>
          <p className="text-sm font-bold text-ink">{u.monthly_saved_assets || 0} assets · ${u.monthly_cost_usd.toFixed(2)}</p>
        </div>
        {isLow && (
          <a href="/settings?tab=billing" data-testid="forge-usage-upgrade"
            className="rounded-full ashra-gradient-bg px-3 py-1.5 text-xs font-semibold text-white inline-flex items-center gap-1 shrink-0">
            Upgrade <ArrowUpRight className="h-3 w-3" />
          </a>
        )}
      </div>
    </div>
  );
}
